import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import {
  mapRestPlacesToCardItems,
  useSelectRestPlace,
} from 'features/kyrgyzstan/select-rest-place'

import { kyrgyzstanRestPlacesStore } from 'entities/kyrgyzstan/model'
import { RestPlacesHorizontalLayout } from 'entities/kyrgyzstan/ui/rest-places-horizontal'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const RestPlaces = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    kyrgyzstanRestPlacesStore.loadIfNeeded()
  }, [])

  const places = kyrgyzstanRestPlacesStore.getRestPlaces()
  const title = kyrgyzstanRestPlacesStore.getTitle()
  const { isLoading } = kyrgyzstanRestPlacesStore

  const preparedPlaces = mapRestPlacesToCardItems(places)
  const handleCardSelect = useSelectRestPlace(places)

  const isEmpty = !isLoading && preparedPlaces.length === 0

  if (isEmpty) {
    return null
  }

  const handleViewAll = () => {
    navigate(RoutingPaths.kyrgyzstan.restPlaces.path())
  }

  return (
    <div className={s.container}>
      <div className={s.header}>
        {title ? (
          <h2 className={clsx(s.title, 'bold-16')}>{title}</h2>
        ) : (
          <Skeleton className={s.skeletonBigTitle} />
        )}

        {!isEmpty && (
          <button
            type="button"
            className={s.viewAll}
            onClick={handleViewAll}
          >
            <span className="medium-14">
              {t('kyrgyzstan_block.rest_places.view_all')}
            </span>
            <AppIcon
              id={AllIcons.CHEVRON_RIGHT}
              width={12}
              height={12}
            />
          </button>
        )}
      </div>

      <RestPlacesHorizontalLayout
        places={preparedPlaces}
        isLoading={isLoading}
        onSelectPlace={handleCardSelect}
      />
    </div>
  )
})
